<template>
    <div class="rcs-live-preview-wrapper"
         :style="{'--accent-color': config.accentColor}">
        <div class="rcs-phone-frame">
            <div class="rcs-preview-content">
                <div class="rcs-preview-banner">
                    <img
                        alt="Banner"
                        :src="config.banner"
                        v-if="config.banner">
                    <div v-else>
                        Your banner will appear here
                    </div>
                </div>
                <div class="rcs-preview-body">
                    <div class="rcs-preview-logo-wrap">
                        <div
                            v-if="config.logo"
                            class="rcs-preview-logo">
                            <img
                                :src="config.logo"
                                alt="Logo">
                        </div>
                        <div
                            v-else
                            class="rcs-preview-logo rcs-preview-logo-placeholder text-sm">
                            Logo
                        </div>
                    </div>
                    <h2 class="rcs-preview-company-name">
                        {{ displayBrandName }}
                    </h2>
                    <p class="rcs-preview-description">
                        {{ displayDescription }}
                    </p>
                    <div class="rcs-preview-contact-icons">
                        <div
                            v-if="hasContactTypePhone"
                            class="rcs-preview-contact-icon">
                            <i class="fa fa-phone"></i>
                            <span>Call</span>
                        </div>
                        <div
                            v-if="hasContactTypeEmail"
                            class="rcs-preview-contact-icon">
                            <i class="fa fa-envelope"></i>
                            <span>Email</span>
                        </div>
                        <div
                            v-if="hasContactTypeWebsite"
                            class="rcs-preview-contact-icon">
                            <i class="fa fa-globe"></i>
                            <span>Website</span>
                        </div>
                    </div>
                    <div class="rcs-preview-tabs">
                        <span class="rcs-preview-tab active col-6 text-center pb-2">Info</span>
                        <span class="rcs-preview-tab col-6 text-center pb-2">Options</span>
                    </div>
                    <div class="rcs-preview-info-list px-2 py-1">
                        <div
                            v-for="(block, index) in contactDetailsWithPrimary"
                            :key="'preview-contact-' + index"
                            class="rcs-preview-info-row align-items-center">
                            <i
                                :class="contactBlockIconClass(block.contactType)"
                                class="rcs-preview-info-icon">
                            </i>
                            <div class="rcs-preview-info-text">
                                <div class="rcs-preview-info-primary text-sm">
                                    {{ block.primary || infoLabel(block.contactType) }}
                                </div>
                                <div class="rcs-preview-info-label">
                                    {{ block?.label || infoLabel(block.contactType) + ' label' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RcsLivePreview',

    props: {
        config: {
            type: Object,
            required: true,
            default: () => ({
                brandName: '',
                logo: '',
                description: '',
                banner: '',
                accentColor: '#313131',
                privacyPolicyUrl: '',
                termsOfServiceUrl: ''
            })
        },
        contactDetails: {
            type: Array,
            required: true,
            default: () => []
        },
        contactTypeOptions: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    computed: {
        displayBrandName() {
            return this.config.brandName || 'Brand Name'
        },

        displayDescription() {
            return this.config.description || 'Brand description'
        },

        hasContactTypePhone() {
            return this.contactDetails.some((b) => b.contactType === 'phone')
        },

        hasContactTypeEmail() {
            return this.contactDetails.some((b) => b.contactType === 'email')
        },

        hasContactTypeWebsite() {
            return this.contactDetails.some((b) => b.contactType === 'website')
        },

        contactDetailsWithPrimary() {
            return this.contactDetails
        }
    },

    methods: {
        contactBlockIconClass(contactType) {
            const map = {
                phone: 'fa fa-phone',
                email: 'fa fa-envelope',
                website: 'fa fa-globe'
            }
            return map[contactType] || 'fa fa-info-circle'
        },

        infoLabel(contactType) {
            return this.contactTypeOptions.find(contactTypeOption => contactTypeOption.value === contactType)?.label
        }
    }
}
</script>
